import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { InfoCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { RootState } from '../../store/index';
import ServiceTable from '../service/serviceTable'
import ServiceTabs from '../service/serviceTabs'
import EzBottom from '../bottom';
import { apiGetPage } from '../../request/api';
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';
import ServiceSwiper from '../service-swiper'

import '../../assets/css/service.css'; // 引入自定义样式

interface ServiceIndexProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (type: 'basic' | 'premium') => void;  // [!++]
    onOpenNote?: (type: any) => void;    // [!++]
}
interface ServiceItem {
    serviceName: string;
    description: string;
    fee: string;
}

interface ApiServiceItem {
    commodityType: string;
    commodityName: string;
    commodityOtherName: string | null;
    marketRemark: string;
}

const ServiceIndex: React.FC<ServiceIndexProps> = ({ handleViewChange, data, onOpenModal, onOpenNote }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { getValue } = useCustomData();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    const serviceHomeSubTitle = getValue('serviceHomeSubTitle');
    const vipMoreInfo = getValue('vipMoreInfo');
    const serviceBuyFirst = getValue('serviceBuyFirst');
    const [loading, setLoading] = useState(true);
    const [packageList, setPackageList] = useState<any[]>([]); // 保存套餐数据
    const [innerList, setInnerList] = useState<any>(); // 保存套餐数据
    const [groupedData, setGroupedData] = useState<Record<string, ServiceItem[]>>({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const rres = await apiGetPage({
                    tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                    page: 1,
                    size: 100,
                    languagecode: languageCode,
                    search: 'id:5645623FFE4341AA9966565CEF756789',
                });
                setInnerList(rres.data.data.rows || [])
                const res = await apiGetPage({
                    tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                    page: 1,
                    size: 100,
                    languagecode: languageCode,
                    search: 'isPackage:0',
                });
                const rows = res.data?.data?.rows || [];
                setPackageList(rows)
                console.log(rows)
                const grouped = rows.reduce((acc: Record<string, ServiceItem[]>, item: ApiServiceItem) => {
                    const category = item.commodityType;
                    const description = item.commodityOtherName
                        ? `(${item.commodityOtherName})`
                        : '';

                    const serviceItem: ServiceItem = {
                        serviceName: item.commodityName,
                        description,
                        fee: item.marketRemark
                    };

                    if (!acc[category]) {
                        acc[category] = [];
                    }
                    acc[category].push(serviceItem);
                    return acc;
                }, {});

                setGroupedData(grouped);
            } catch (error) {
                console.error('Error fetching service data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [languageCode]);

    return (
        <div className='service-index'>
            <ServiceSwiper />
            <div className='service-content'>
                <div className='service-h1'>{serviceHomeSubTitle}</div>
                <ServiceTable
                    handleViewChange={handleViewChange}
                    onOpenModal={onOpenModal}
                    onOpenNote={onOpenNote}
                />
                <div className="service-tab-h1">{vipMoreInfo}</div>
                <div className="service-detail-tab-h2" style={{ color: themeColor }}>
                    <div>{serviceBuyFirst}</div>
                    <div>
                        <InfoCircleOutlined
                            onClick={() => {
                                const List = {
                                    commodityType: innerList[0].commodityType,
                                    commodityRemark: innerList[0].commodityRemark
                                }
                                onOpenNote?.(List);
                            }}
                            style={{ fontSize: '22px' }}
                        />
                    </div>
                </div>
                <ServiceTabs onOpenModal={onOpenModal} onOpenNote={onOpenNote} loading={loading} packageList={packageList} groupedData={groupedData} />
                <EzBottom />
            </div>
        </div>
    )

};

export default ServiceIndex;
